import { defineComponent as r, createBlock as t, openBlock as n, unref as c, mergeProps as l, withCtx as p, createElementVNode as f } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconEiffelTower",
  __name: "IconEiffelTower",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (m, e) => (n(), t(c(i), l(a, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        f("path", {
          "fill-rule": "evenodd",
          d: "M10.256 21.441a.75.75 0 0 1-.75.75h-2.58c-.993 0-1.58-1.09-1.074-1.92a49.503 49.503 0 0 0 2.2-3.994C8.56 15.23 9.01 14.165 9.286 13.23c.42-1.428.771-3.754 1.026-5.876a117.544 117.544 0 0 0 .438-4.376 1.242 1.242 0 0 1 .129-.46L10.887 2.5c.461-.921 1.776-.921 2.237 0l.009.019a1.24 1.24 0 0 1 .128.453 126.939 126.939 0 0 0 .452 4.38c.258 2.123.608 4.455 1.014 5.884.27.95.71 2.007 1.21 3.043a44.764 44.764 0 0 0 2.206 3.982c.514.828-.07 1.93-1.07 1.93h-2.567a.75.75 0 0 1-.75-.75v-.006a1.75 1.75 0 0 0-3.5.006M11.8 7.531c.08-.665.15-1.304.21-1.883a120.874 120.874 0 0 0 .213 1.885c.21 1.722.487 3.658.821 5.158h-2.072c.344-1.504.622-3.44.828-5.16m-1.247 6.66h2.898a19.932 19.932 0 0 0 .64 1.663H9.9a20.865 20.865 0 0 0 .654-1.663m-1.36 3.163h5.6a46.719 46.719 0 0 0 1.853 3.337H15.17a3.251 3.251 0 0 0-6.326 0H7.35a51.446 51.446 0 0 0 1.842-3.337",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
